export interface OrderLocation {
  code: string;
  name: string;
}

export interface ExtraCharge {
  chargeCode: string;
  quantity: number;
  rate: number;
  chargeAmount: number;
}

export interface DiscountCode {
  discountCodeId: number;
  code: string;
  validFromUtc: string;
  validToUtc: string;
  discountPercent: number;
}

export class Order {
  orderId: number;
  orderNumber: string;
  clientRequestId: string;
  origin: OrderLocation;
  destination: OrderLocation;
  orderDetails: OrderDetail[];
  extraCharges: ExtraCharge[];
  discountPercent: number;
  discountAmount: number;
  totalBaseAmount: number;
  totalExtraChargeAmount: number;
  subTotalAmount: number;
  totalAmount: number;
  declaredValue: number;
}

// generated via https://quicktype.io/ from json response, not definitive
export interface OrderDetail {
  orderDetailId: number;
  description: string;
  weight: number;
  weightUnit: string;
  length: number;
  lengthUnit: string;
  width: number;
  widthUnit: string;
  height: number;
  heightUnit: string;
  cube: number;
  cubeUnit: string;
  density: number;
  minimumCharge: number;
  isMinimumChargeUsed: boolean;
  rate: number;
  pieces: number;
  pieceUnit: string;
  ratePer: number;
  ratePerUnit: string;
  ratingQuantity: number;
  subTotalAmount: number;
  totalAmount: number;
}




export class FreightDetail {
  description: string;

  weight: number;
  weightUnit: string;

  pieces: number;
  pieceUnit: string;
  length: number;
  lengthUnit: string;
  width: number;
  widthUnit: string;
  height: number;
  heightUnit: string;

  static getFormattedWeight(detail: FreightDetail) {
    if (!detail?.weight || !detail?.weightUnit) {
      console.warn('empty weight and/or weightUnit for detail: ', detail);
      return '';
    } else if (detail?.weightUnit === 'LB') {
      return detail.weight + ' lbs.';
    } else {
      return detail.weight + ' ' + detail.weightUnit.toLowerCase() + '.';
    }
  }

  static getFormattedDimension(dimKey: 'length' | 'width' | 'height', detail: FreightDetail) {
    if (!detail) {
      return;
    }
    const value = detail[dimKey];
    const unit = detail[dimKey + 'Unit'] as string|undefined;
    if (!detail || !value || !unit) {
      console.warn('empty dimension and/or dimension unit for detail ', detail);
      return;
    }

    return `${value.toString().toLowerCase()} ${unit.toLowerCase()}.`;
  }
}
